import { initState, types } from "./types";

const sortRules = (list) =>
  [...list].sort((a, b) => {
    // Pinned-by-creation: newest first (createdAt desc). Falls back to name.
    const ta = a?.createdAt ? Date.parse(a.createdAt) : 0;
    const tb = b?.createdAt ? Date.parse(b.createdAt) : 0;
    if (ta !== tb) return tb - ta;
    return (a?.name || "").localeCompare(b?.name || "");
  });

const performanceAlertsReducer = (state = initState, action) => {
  switch (action.type) {
    case types.GET_ALERTS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.GET_ALERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: sortRules(action.list || []),
        error: null,
      };

    case types.GET_ALERTS_FAILED:
      return { ...state, loading: false, error: action.error };

    case types.CREATE_ALERT_REQUEST:
    case types.UPDATE_ALERT_REQUEST:
    case types.DELETE_ALERT_REQUEST:
    case types.TOGGLE_ALERT_REQUEST:
      return { ...state, saving: true, error: null };

    case types.CREATE_ALERT_SUCCESS: {
      const { alert } = action;
      if (!alert) return { ...state, saving: false };
      const next = sortRules([
        ...state.list.filter((r) => r._id !== alert._id),
        alert,
      ]);
      return { ...state, saving: false, list: next };
    }

    case types.UPDATE_ALERT_SUCCESS:
    case types.TOGGLE_ALERT_SUCCESS: {
      const { alert } = action;
      if (!alert) return { ...state, saving: false };
      const next = sortRules(
        state.list.map((r) => (r._id === alert._id ? alert : r)),
      );
      return { ...state, saving: false, list: next };
    }

    case types.DELETE_ALERT_SUCCESS: {
      const { id } = action;
      return {
        ...state,
        saving: false,
        list: state.list.filter((r) => r._id !== id),
      };
    }

    case types.CREATE_ALERT_FAILED:
    case types.UPDATE_ALERT_FAILED:
    case types.DELETE_ALERT_FAILED:
    case types.TOGGLE_ALERT_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
};

export default performanceAlertsReducer;
